var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mapBox"},[_c('GmapMap',{ref:"mapRef",staticClass:"map-main",attrs:{"center":_vm.marker.position,"zoom":15}},[_c('GmapMarker',{staticClass:"map-marker",attrs:{"position":_vm.marker.position,"clickable":true,"icon":_vm.marker.markerData,"label":_vm.marker.label},on:{"click":_vm.marker.position}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }